import React from 'react';
import { getCurrencySymbol, formatTransactionAmount } from './balanceUtils';

const userLang = navigator.language || navigator.userLanguage;

/**
 * Displays a list of merchant's transaction history
 */
const TransactionHistory = ({ 
  transactions, 
  isLoading, 
  error
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">
        {userLang === 'zh-CN' ? '最近交易' : 'Recent Transactions'}
      </h3>
      
      {/* Show loading indicator when fetching transactions */}
      {isLoading && (
        <div className="flex justify-center py-6">
          <svg className="animate-spin h-6 w-6 text-brand-teal" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
          </svg>
        </div>
      )}
      
      {/* Show transactions */}
      {!isLoading && transactions?.length > 0 ? (
        <div className="space-y-4">
          {transactions.map((transaction, index) => {
            const currencySymbol = getCurrencySymbol(transaction.currency || 'usd');
            const formattedTransactionString = formatTransactionAmount(transaction);
            const date = new Date(transaction.created * 1000).toLocaleDateString();
            
            return (
            <div key={transaction.id || index} className="flex items-center justify-between py-3 border-b last:border-0">
              <div>
                <p className="font-medium text-gray-900">{transaction.description || transaction.type}</p>
                  <p className="text-sm text-gray-500">{date}</p>
              </div>
              <div className={`font-medium ${transaction.net > 0 ? 'text-green-600' : 'text-red-600'}`}>
                  {formattedTransactionString}
                </div>
              </div>
            );
          })}
        </div>
      ) : !isLoading ? (
        <p className="text-gray-500 text-center py-4">
          {userLang === 'zh-CN' ? '暂无交易记录' : 'No transactions yet'}
        </p>
      ) : null}
      
      {/* Show error if balance fetch failed */}
      {error && (
        <div className="mt-4 text-sm text-red-600">
          <p>{error.error || 'Failed to load transactions'}</p>
        </div>
      )}
    </div>
  );
};

export default TransactionHistory; 